module.exports = __webpack_public_path__ + "img/1474505415.312d39d3.jpg";